<app-header>
   <jbm-view-title
     [caption]="'entity.resources'|translate"
     [parentLinkCaption]="'menu.settings'|translate"
     [itemcount]="queryHttpHelper.paginationProps.itemCount"
     [parentLinkSlug]="'settings'">
   </jbm-view-title>
   <jbm-create-button [visible]="userRights.AllowCreate" (click)="startCreate()" [className]="'float-start'"></jbm-create-button>
   <div class="toolbar float-start ml-4">
      <div class="toolbar-spacer-2"></div>
      <label>{{'entity.type'|translate}}</label>
      <select (change)="changeType($event)" class="form-control form-control-sm form-select">
         <option *ngFor="let type of typeOptions" value="{{type.key}}">{{type.value}}</option>
      </select>
   </div>
   <div class="toolbar float-end">
      <jbm-pagination [itemCount]="queryHttpHelper.paginationProps.itemCount"
        [pageSize]="queryHttpHelper.paginationProps.pageSize"
        [page]="queryHttpHelper.paginationProps.page"
        (pageClick)="pageChange($event)">
      </jbm-pagination>
      <jbm-searchbox
        [search]="queryHttpHelper.getSearchValue()"
        [minlength]="3"
        (searchChange)="searchChange($event)">
      </jbm-searchbox>
      <jbm-help-button [helpTopicID]="0"></jbm-help-button>
   </div>
</app-header>
<section class="module resources">
   <div class="table-responsive">
      <table class="table padding table-sm bg-white" [ngClass]="{'table-row-selectable table-hover': userRights.AllowUpdate}">
         <thead>
         <tr>
            <th [hidden]="true"></th>
            <th jbm-table-column class="code" [name]="'code'" [header]="'entity.code'|translate" width="16" [sortable]="false"></th>
            <th jbm-table-column class="description" [name]="'description'" [header]="'entity.description'|translate"
              [sortable]="true" [sorted]="true" [sortdirection]="'+'" (sortChange)="sortChange($event)"></th>
            <th class="actions editable"></th>
         </tr>
         </thead>
         <tbody>
         <tr *ngIf="createActive" [ngClass]="{ 'has-error': (codeTouched && codeError!='') || (descriptionTouched && descriptionError!='') }">
            <th [hidden]="true"></th>
            <td>
               <input class="form-control form-control-sm" type="text" autocomplete="off" [(ngModel)]="code"
                 (change)="onChangeCode()" [ngClass]="{'ng-valid':validateCode() && codeUnique, 'is-invalid':this.codeTouched && !validateCode() || !codeUnique }">
               <div *ngIf="codeError" class="invalid-feedback">{{codeError}}</div>
            </td>
            <td>
               <input class="form-control form-control-sm" type="text" autocomplete="off" [(ngModel)]="description"
                 (change)="onChangeDescription()" [ngClass]="{'ng-valid':validateDescription() && descriptionUnique, 'is-invalid':this.descriptionTouched && !validateDescription() || !descriptionUnique }">
               <div *ngIf="descriptionError" class="invalid-feedback">{{descriptionError}}</div>
            </td>
            <td class="editable actions">
               <button type="button" class="btn btn-sm btn-primary mr-1" [disabled]="!validateCode() || !validateDescription()" (click)="createItem()">{{'ui.save'|translate}}</button>
               <button type="button" class="btn btn-sm btn-secondary" (click)="createCancel()">{{'ui.cancel'|translate}}</button>
            </td>
         </tr>
         <tr *ngFor="let item of items" (click)="startEditing(item.id)" [ngClass]="{'has-error': item.editing && ((codeTouched && codeError!='') || (descriptionTouched && descriptionError!=''))}">
            <td [hidden]="true"></td>
            <td *ngIf="!item.editing">{{item.code}}</td>
            <td *ngIf="item.editing" class="editable">
               <input class="form-control form-control-sm" type="text" autocomplete="off"
                 [(ngModel)]="code" [placeholder]="item.code" (change)="onChangeCode()" [ngClass]="{'ng-valid':validateCode() && codeUnique, 'is-invalid':!validateCode() || !codeUnique }">
               <div *ngIf="codeError" class="invalid-feedback">{{codeError}}</div>
            </td>
            <td *ngIf="!item.editing">{{item.description}}</td>
            <td *ngIf="item.editing" class="editable">
               <input class="form-control form-control-sm" type="text" autocomplete="off"
                 [(ngModel)]="description" [placeholder]="item.description" (change)="onChangeDescription()" [ngClass]="{'ng-valid':validateDescription() && descriptionUnique, 'is-invalid':!validateDescription() || !descriptionUnique }">
               <div *ngIf="descriptionError" class="invalid-feedback">{{descriptionError}}</div>
            </td>
            <td *ngIf="!item.editing" class="actions">
               <button *ngIf="userRights.AllowUpdate" class="btn btn-primary btn-sm float-end mr-2"><i class="far fa-edit"></i></button>
            </td>
            <td *ngIf="item.editing" class="editable actions">
               <button type="button" class="btn btn-sm btn-success mr-1"
                 [disabled]="!validateCode() || !validateDescription()" (click)="updateItem()">{{'ui.save'|translate}}</button>
               <button type="button" class="btn btn-sm btn-secondary" (click)="cancelEditing()">{{'ui.cancel'|translate}}</button>
            </td>
         </tr>
         </tbody>
      </table>
      <jbm-empty-view [emptyView]="queryHttpHelper.paginationProps.itemCount==0"></jbm-empty-view>
   </div>
</section>
